import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const drawerWidth = "240px";
export const cardWidth = "450px";

export default makeStyles((theme: Theme) =>
	createStyles({
		mainRoot: {
			display: "flex",
			flexDirection: "column",
			justifyContent: "space-between",
			paddingTop: "2px",
			flexGrow: 1,
			minHeight: "calc(100vh - 76px)",
		},
		menuButton: {
			marginRight: theme.spacing(2),
		},
		hide: {
			display: "none",
		},
		white: {
			color: theme.palette.secondary.main,
		},
		bold: {
			fontWeight: 800,
		},
		semiBold: {
			fontWeight: 600,
		},
		regular: {
			fontWeight: 400,
		},
		ml1: {
			marginLeft: theme.spacing(1),
		},
		modulesRoot: {
			width: "100%",
			display: "flex",
			flexDirection: "row",
			overflow: "hidden",
			marginLeft: theme.spacing(3),
		},
		pl4: {
			paddingLeft: theme.spacing(4),
		},
		submit: {
			margin: theme.spacing(3, 0, 2),
			fontWeight: 600,
		},
		mb3: {
			marginBottom: theme.spacing(3),
		},
		mt1: {
			marginTop: theme.spacing(1),
		},
		mr3: {
			marginRight: theme.spacing(2),
		},
		breadcrumbs: {
			maxWidth: "70%",
			marginLeft: theme.spacing(0.2),
			fontWeight: 600,
		},
		mlBottomDrawer: {
			marginLeft: theme.spacing(8),
		},
		ml2neg: {
			marginLeft: "-10px",
		},
		linkButton: {
			textDecoration: "none",
		},
		bgPrim: {
			backgroundColor: theme.palette.primary.main,
			height: "4px",
			borderRadius: "10px",
			marginTop: "-4px",
		},
		bgWhite: {
			backgroundColor: "white",
			height: "4px",
			borderRadius: "10px",
			marginTop: "-4px",
		},
		toolBar: {
			paddingTop: theme.spacing(1),
			paddingInline: theme.spacing(9),
		},
		inboxBadge: {
			"& .MuiBadge-badge": {
				backgroundColor: "#ed544d",
				color: theme.palette.secondary.main,
				top: "6px",
				maxWidth: "30px",
				border: "1px solid #fff",
			},
		},
		inboxBadgeTopRight: {
			"& .MuiBadge-badge": {
				right: "-8px",
				top: "14px",
			},
		},
		popperRoot: {
			position: "absolute",
			top: "103px",
			right: "72px",
		},
		inboxWindow: {
			width: "917px",
			height: "657px",
			padding: "24px",
			paddingBottom: 0,
		},
		closeInboxButton: {
			position: "absolute",
			top: "4px",
			right: "4px",
		},
		inboxTab: {
			"&.MuiTab-root": {
				minWidth: "140px",
				minHeight: "32px",
				color: theme.palette.tableText.main,
				textTransform: "capitalize",
				fontSize: "22px",
				fontWeight: 300,
				opacity: 1,
				"&:hover": {
					backgroundColor: "rgba(55, 125, 246, 0.05)",
					borderRadius: "2px",
					fontWeight: 600,
					color: theme.palette.primary.main,
				},
			},
			"&.MuiButtonBase-root.Mui-disabled": {
				opacity: 1,
				color: "#96939266",
				"&:hover": {
					backgroundColor: "transparent",
					fontWeight: 300,
					color: "#96939266",
				},
			},
		},
		activeTab: {
			color: theme.palette.primary.main,
			fontWeight: 600,
		},
		menuList: {
			padding: theme.spacing(2, 0),
		},
		menuItem: {
			padding: theme.spacing(1, 3),
		},
		itemLink: {
			textDecoration: "none",
			color: theme.palette.text.primary,
			"&.MuiLink-underlineHover:hover ": {
				textDecoration: "none",
			},
		},
	})
);
